import { Component, NgZone } from '@angular/core';

import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';

import moment from 'moment';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { File } from '@ionic-native/file';
//import { Camera, CameraOptions } from '@ionic-native/camera';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { UEData } from '../../providers/ue-data';
import { ParplatzData } from '../../providers/pp-data';
import { UEModel } from '../ue/ue-model';
import { UEUploadPage } from '../ue/ue-upload';
import { PPListPage } from '../pp-list/pp-list';
import { KontrollenData } from '../kontrollen/kontrollen-data';
import { Platform } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { ParkbewilligungenData, PbKategorieTyp } from '../parkbewilligungen/parkbewilligungen-data';


import { Camera, CameraOptions } from '@ionic-native/camera';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { LicenseplateProvider } from '../../providers/licenseplate/licenseplate';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';


declare var CordovaExif : any;
//declare var cordova : any;
declare var FileTransfer : any;
declare var HTMLImageElement : any;
declare var navigator : any;
declare var device : any;

@Component({
  selector: 'ue-create',
  templateUrl: 'ue-create.html'
})
export class UECreatePage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  sPressedButton = "";

  debug = "";

  sBtnQRColor = this.sNormalColor;
  sBtnAutoColor = this.sNormalColor;
  sBtnAuto2Color = this.sNormalColor;
  sBtnAuto3Color = this.sNormalColor;
  sBtnBeweisColor = this.sNormalColor;

  sBtnQR;  
  sBtnAuto;  
  sBtnAuto2;  
  sBtnAuto3;  
  sBtnBeweis;  
  sBtnErfassen;  
  
  bShowDatum1;
  bShowDatum2;
  bShowDatum3;
  bShowDatumBeweis;
  //autonummer;

  oSelectedPP;

  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public ueData: UEData
            , public ppData: ParplatzData
            , public kontrollenData: KontrollenData            
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , public ueModel: UEModel 
            , public camera: Camera
            , public barcodeScanner:BarcodeScanner
            , public domSanitizer: DomSanitizer
            , public file: File
            , public alertCtrl: AlertController
            , public pbData : ParkbewilligungenData
            , public platform:Platform
            //, private lpProvider: LicenseplateProvider

            ) {
    //let selectedpp = navParams.get('pp');
    this.oSelectedPP = navParams.data.pp;
    this.init();

    if(navParams.data.fkkontrolle){
      this.ueModel.fkkontrolle = navParams.data.fkkontrolle;
    }
    if(navParams.data.plate){
      this.ueModel.autonummer = navParams.data.plate;
    }

    if(this.pbData.pbResult){
      this.ueModel.checkresultdata = JSON.stringify(this.pbData.pbResult);
      //-- Check Data wieder löschen -------
      this.pbData.pbResult = null;
    }    
    //console.log(this.ueModel);
    if(navParams.data.uselprscanimage){
      //console.log("uselprscanimage !!");
      //console.log(this.kontrollenData.lppicture);
      this.zone.run(() => {         
          this.sBtnAutoColor = this.sCheckedColor;
          this.sBtnAuto = moment().format();
          this.ueModel.srcPhotoAuto= this.kontrollenData.lppicture;
          this.ueModel.sDateTimeAuto = moment().format();
        });
    }
    //console.log(this.navParams.data);
    this.ueModel.iGrundid = navParams.data.pp.grundid;

   }
   

   init(){
    let iStepNo = 1;
    
    this.sBtnQR = iStepNo+'. Scan QR-Code';  
    iStepNo++;
    this.sBtnAuto = iStepNo+'. Foto Fahrzeug';  
    this.sBtnAuto2 = iStepNo+'b. Foto Reserve';  
    iStepNo++;
    if(this.oSelectedPP.extrabeweis == 1){
      this.sBtnBeweis = iStepNo+'. Foto Frontscheibe';  
      iStepNo++;    
    }
    if(this.oSelectedPP.kontrollprozess == 0){
      this.sBtnBeweis = iStepNo+'. Foto Beweis';      
      iStepNo++;    
    }
    this.sBtnErfassen= iStepNo+'. Erfassen';  


    this.sBtnQRColor = this.sNormalColor;
    this.sBtnAutoColor = this.sNormalColor;
    this.sBtnAuto2Color = this.sNormalColor;
    this.sBtnAuto3Color = this.sNormalColor;
    this.sBtnBeweisColor = this.sNormalColor;   

    this.bShowDatum1 = false;
    this.bShowDatum2 = false;
    this.bShowDatum3 = false;
    this.bShowDatumBeweis = false;

    this.sPressedButton = "";
    //this.autonummer = "";
    this.ueModel.clear();
   }

   onUploadUE(){
     if(!this.common.wifierror){
       //-- Wenn Desktop Testmodus -----
      if(!this.platform.is('cordova') && this.common.staging == "staging"){
        let ueUploadModal = this.modalCtrl.create(UEUploadPage, {grundid:this.navParams.data.pp.grundid, fkkontrolle:this.navParams.data.fkkontrolle});
        ueUploadModal.onDidDismiss(data => {
          //this.navCtrl.popToRoot();
          console.log("ueUploadModal dismiss");
          //-- increment counter for kontrolle --
          this.kontrollenData.actkontrolleuecount = this.kontrollenData.actkontrolleuecount+1;

          this.kontrollenData.lppicture = "";
                    
          this.navCtrl.pop();
        });      
        ueUploadModal.present();    
        return;     
       }

       //Kontrollprozess
       if(this.ueModel.srcPhotoBeweis == "" && (this.oSelectedPP.kontrollprozess == 0) ){
          let toast = this.toastCtrl.create({
            message: 'Bitte Beweisbild erstellen z.B. Frontscheibe',
            dismissOnPageChange: true,
            duration: 3000,
            position: 'middle',
            //cssClass: 'warning',
            //closeButtonText: 'schliessen'
            //showCloseButton: true
          });
          toast.present();  
          return;         
       }       
       //Extrabeweis
       //console.log("Beweis:");
       //console.log(this.ueModel.srcPhotoBeweis);
       if(this.ueModel.srcPhotoBeweis == "" && (this.oSelectedPP.extrabeweis == 1) ){
          let toast = this.toastCtrl.create({
            message: 'Bitte Bild der Frontscheibe erstellen',
            dismissOnPageChange: true,
            duration: 3000,
            position: 'middle',
            //cssClass: 'warning',
            //closeButtonText: 'schliessen'
            //showCloseButton: true
          });
          toast.present();  
          return;         
       }       

        if(this.ueModel.srcPhotoAuto){
          let ueUploadModal = this.modalCtrl.create(UEUploadPage, {grundid:this.navParams.data.pp.grundid, fkkontrolle:this.navParams.data.fkkontrolle});
          ueUploadModal.onDidDismiss(data => {
            //this.navCtrl.popToRoot();
            console.log("ueUploadModal dismiss");
            //-- increment counter for kontrolle --
            this.kontrollenData.actkontrolleuecount = this.kontrollenData.actkontrolleuecount+1;

            this.kontrollenData.lppicture = "";
                      
            this.navCtrl.pop();
          });      
          ueUploadModal.present();
        }
        else{
          let toast = this.toastCtrl.create({
            message: 'Kein Fahrzeugbild vorhanden. Bitte Fahrzeug-Bild laden',
            dismissOnPageChange: true,
            duration: 3000,
            position: 'middle',
            //cssClass: 'warning',
            //closeButtonText: 'schliessen'
            //showCloseButton: true
          });
          toast.present();       
        }
     }
     else{
        this.common.showWifiError();  
     }

   }

  onTakePhoto(sBtn) {

    this.sPressedButton = sBtn;

    let options: CameraOptions = {
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      quality: this.userData.imagequality,
      targetWidth: 1200,
      targetHeight: 1200,
      saveToPhotoAlbum:this.userData.storeimageslocally, 
      correctOrientation: true
    }
 
    this.camera.getPicture(options).then((result) => {
            var imgdata = JSON.parse(result);
            let sNow = moment().format();

            this.onSuccessImage(imgdata.filename, sNow);
    });

  }
  /*
 onOpenGallery(sBtn){
    this.sPressedButton = sBtn;
    let cameraOptions = {
      sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY,
      destinationType: navigator.camera.DestinationType.FILE_URI,      
      quality: this.userData.imagequality,
      targetWidth: 1200,
      targetHeight: 1200,
      saveToPhotoAlbum:false, 
      correctOrientation: true
    }     

    navigator.camera.getPicture( this.onSuccessImage.bind(this), this.onFail, cameraOptions );    

 }
*/
   onOpenGallery(sBtn){
    this.sPressedButton = sBtn;

    let options: CameraOptions = {
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      destinationType: this.camera.DestinationType.FILE_URI,
     encodingType: this.camera.EncodingType.JPEG,
     mediaType: this.camera.MediaType.PICTURE,
     quality: this.userData.imagequality,
     targetWidth: 1200,
     targetHeight: 1200,
     saveToPhotoAlbum:false, 
     correctOrientation: true
   }

   this.camera.getPicture(options).then((result) => {
    
    let img ="";     
    var imgdata = JSON.parse(result);
    //console.log(imgdata);
    //console.log("JSON::");
    var metadata = JSON.parse(imgdata.json_metadata);
    if(metadata && metadata.Exif && metadata.Exif.DateTimeOriginal){
      let isodate = this.common.exiftoiso(metadata.Exif.DateTimeOriginal);
      //console.log(isodate);
      this.onSuccessImage(imgdata.filename, moment(isodate).format());   
    }
    else{
      console.log("Kein Datum");
      console.log(metadata);
      if(this.sPressedButton == "auto"){
        this.bShowDatum1 = true;                  
      }
      else if(this.sPressedButton == "auto2"){
        this.bShowDatum2 = true;
      }
      else if(this.sPressedButton == "auto3"){
        this.bShowDatum3 = true;                  
      }
      else if(this.sPressedButton == "beweis"){
        this.bShowDatumBeweis = true;                  
      }
      let sNow = moment().format();
      this.onSuccessImage(imgdata.filename, sNow);        

    }
    //console.log(metadata);
    //console.log(metadata.Exif.DateTimeOriginal);
    //this.onSuccessImage(imgdata.filename, moment(isodate).format());
      /*
      this.file.resolveLocalFilesystemUrl(result).then(fileEntry => {
        console.log("file:");
        console.log(fileEntry);
        
        CordovaExif.readData(fileEntry.toInternalURL(), function(exifObject) {
          //ist "DateTimeOriginal":"2018:04:26 18:01:03",
          //soll: 2018-04-27T08:50:38+02:00
          console.log("internal:");
          console.log(exifObject);
           
          if(exifObject){
            if(exifObject.DateTimeOriginal){
              let isodate = this.common.exiftoiso(exifObject.DateTimeOriginal);
              console.log(isodate);
              this.onSuccessImage(fileEntry.toInternalURL(), moment(isodate).format());                  
            }
            else{
              console.log("probiere andere meta");
              
              fileEntry.getMetadata(function(meta){    
                if(this.sPressedButton == "auto"){
                  this.bShowDatum1 = true;                  
                }
                else if(this.sPressedButton == "auto2"){
                  this.bShowDatum2 = true;
                }
                else if(this.sPressedButton == "auto3"){
                  this.bShowDatum3 = true;                  
                }
                else if(this.sPressedButton == "beweis"){
                  this.bShowDatum4 = true;                  
                }
                this.onSuccessImage(imagedata, moment(meta.modificationTime).format());        
                //this.kontrollenData.aBeweise.push({beweisno:iBeweisno, filename:file, datetime:moment(meta.modificationTime).format(), bewid:bewid, class:""});
                        
              }.bind(this));              
              
            }

          }
          else{
            let toast = this.toastCtrl.create({
              message: 'Fehler, bitte Bildformat umstellen',
              position: 'top',
              cssClass: 'toast-success',
              duration: 2000
            });
            toast.present();               
          }
          
        }.bind(this));        

      })  
      */
    });          
 }


 onSuccessImage(sFileURL, sDatetime) {
    this.zone.run(() => { 
      if(this.sPressedButton == "auto"){
        this.sBtnAutoColor = this.sCheckedColor;
        this.ueModel.srcPhotoAuto= sFileURL;
        this.ueModel.sDateTimeAuto = sDatetime;
        this.sBtnAuto = sDatetime;
        //this.ueModel.autonummer = "";
        /*
        this.zone.run(() => { 
          this.lpProvider.localFindAutonummer(sFileURL).then((res: [any]) => {
            if(res.length>0){
              this.common.tmp = res[0].number;
              this.ueModel.autonummer = res[0].number;
            }
            
        
          })
          .catch((error: Error) => console.error(error));    
          
      }); 
      */

      }
      else if(this.sPressedButton == "auto2"){
        this.sBtnAuto2Color = this.sCheckedColor;
        this.ueModel.srcPhotoAuto2= sFileURL;
        this.ueModel.sDateTimeAuto2 = sDatetime;
        this.sBtnAuto2 = sDatetime;

      }
      else if(this.sPressedButton == "auto3"){
        this.sBtnAuto3Color = this.sCheckedColor;
        this.ueModel.srcPhotoAuto3= sFileURL;
        this.ueModel.sDateTimeAuto3 = sDatetime;
        this.sBtnAuto3 = sDatetime;

      }        
      else if(this.sPressedButton == "beweis"){
        this.sBtnBeweisColor = this.sCheckedColor;
        this.ueModel.srcPhotoBeweis= sFileURL;
        this.ueModel.sDateTimeBeweis = sDatetime;
        this.sBtnBeweis = sDatetime;

      }   

    });   


}
/*
onUpdateAutonummer(){
  setTimeout(()=>{ this.display = "" }, 4000);
}
*/
 onFail(message) {
    //alert('Failed because: ' + message);
}

  onCopy(file){
                      console.log("download complete: " + file.toURL());
                      console.log(file);
                      //this.srcPhotoAuto = "hallo";
  }

  onScanQR() {
    let config = {
            torchOn: true,
            showTorchButton: true
    };

    this.barcodeScanner.scan(config).then(async (barcodeData) =>  {
    // Success! Barcode data is here
    if(barcodeData.format == "QR_CODE"){
      
      if(barcodeData.text.includes("parkix.ch")){
        let sQR = barcodeData.text;
        let aQR = sQR.split("/");
        let strURLIdent = aQR[aQR.length-1]; // Scanned code

        //get mandat for sqrcode
        //let mandat_id = await this.ueData.getMandatByURLIdent(strURLIdent);
        let bUEAssignable = await this.ueData.checkUEAssignableToPP(strURLIdent, this.ueModel.iGrundid);
        
        if(bUEAssignable){

          //-- Check if UE already scanned --------
          let bUEScannedAlready = await this.ueData.checkUEScannedAlready(strURLIdent);
          if(!bUEScannedAlready){
            this.ueModel.sQRCode = aQR[aQR.length-1]; // Scanned code
            this.sBtnQR = 'UE Ref-Nr.: '+this.ueModel.sQRCode;
            this.sBtnQRColor = this.sCheckedColor;  
          }
          else{
            let alert = this.alertCtrl.create();
            alert.setTitle("UE wurde bereits gescannt, soll die UE erneut verwendet werden? Bestehende Daten werden überschrieben!");
            alert.addButton({
              text: 'JA, UE erneut verwenden',
              handler: (data: any) => {
                this.ueData.overrideUE(strURLIdent);
                this.ueModel.sQRCode = aQR[aQR.length-1]; // Scanned code
                this.sBtnQR = 'UE Ref-Nr.: '+this.ueModel.sQRCode;
                this.sBtnQRColor = this.sCheckedColor;  
      
              }
            });
            alert.addButton({
              text: 'Nein',
              handler: (data: any) => {
      
              }
            });
            alert.present();    
              
          }
        }
        else{

          let alert = this.alertCtrl.create();
          alert.setTitle("Falsche Umtriebsentschädigung für diesen Parkplatz. Bitte korrekte UE für diesen Parkplatz verwenden und nochmals scannen!");
          alert.addButton({
            text: 'Ok, ich verwende andere UE',
            handler: (data: any) => {

            }
          });
          alert.present();    
       
        }
  
      }
      else{
        let toast = this.toastCtrl.create({
          message: 'Ungültiger QR-Code',
          position: 'top',
          cssClass: 'toast-success',
          duration: 2000
        });
        toast.present();             
      }


      

    }
    else{
            let toast = this.toastCtrl.create({
              message: 'Kein gültiger QR-Code',
              position: 'top',
              cssClass: 'toast-success',
              duration: 2000
            });
            toast.present();     
    }



    }, (err) => {
        // An error occurred
        console.log(err);
    });
  }

  onSignup() {
    //this.navCtrl.push(SignupPage);
  }


  
}



// WEBPACK FOOTER //
// ./src/pages/ue/ue-create.ts